import { ClientSessionFilter } from "../api/contracts";
import { clientWorkspacePath } from "../config/navigation";

export const SESSION_PAGE_SIZE = 50;
export function sessionOffset(value: string | null): number {
  const number = value !== null && /^\d+$/.test(value) ? Number(value) : 0;
  return Number.isSafeInteger(number) &&
    number <= 2147483647 &&
    number % SESSION_PAGE_SIZE === 0
    ? number
    : 0;
}
export function sessionLocation(search: string) {
  const query = new URLSearchParams(search);
  return {
    filter: (query.get("filter") === "all"
      ? "all"
      : "past-week") as ClientSessionFilter,
    pageOffset: sessionOffset(query.get("pageOffset")),
    messageOffset: sessionOffset(query.get("messageOffset")),
  };
}

// Construct local routes from known IDs and view state; never accept a return URL.
export function clientSessionPath(
  patientId: string,
  source: "my-clients" | "team",
  search: string,
  sessionId?: string,
  messageOffset = 0,
): string {
  const current = new URLSearchParams(search);
  const state = sessionLocation(search);
  const query = new URLSearchParams();
  query.set("filter", state.filter);
  if (state.pageOffset) query.set("pageOffset", String(state.pageOffset));
  for (const key of ["clinicId", "db"]) {
    const value = current.get(key);
    if (value) query.set(key, value);
  }
  if (sessionId && messageOffset)
    query.set("messageOffset", String(messageOffset));
  const suffix = sessionId
    ? `sessions/${encodeURIComponent(sessionId)}`
    : "sessions";
  return `${clientWorkspacePath(patientId, suffix, source)}?${query.toString()}`;
}
